/**
 * Analytics placeholder hooks.
 * Replace with real Meta Pixel / GA event calls when ready.
 * No real IDs are hardcoded.
 */

export function trackWaitlistSubmission(data) {
  // Meta Pixel placeholder
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Lead', {
      content_name: 'waitlist_submission',
      content_category: data.interest,
    });
  }

  // Google Analytics placeholder
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'waitlist_submit', {
      event_category: 'engagement',
      event_label: data.interest,
    });
  }

  // Console log for dev
  console.log('[Analytics] Waitlist submission tracked:', data.interest);
}

export function trackCTAClick(ctaName) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'cta_click', {
      event_category: 'engagement',
      event_label: ctaName,
    });
  }
  console.log('[Analytics] CTA click:', ctaName);
}

export function trackPageView() {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view');
  }
  console.log('[Analytics] Page view tracked');
}
